import { useState } from 'react';

import { removeTralingAndEmptyParamFromUrl } from '@utils/utils';

import type { QueryMapSetup } from '@src/types/minhelseentities';

/**
 * Oppdaterer både React-state og URL-en og støtter QueryParams med flere verdier
 * Metoden håndterer logikk for når parameteret skal settes eller fjernes fra URL-en,
 * og sørger for at endringer i inputverdier synkroniseres med nettleserens URL og evt. query params.
 * Brukes både for å skrive til og lese fra query-parametre, slik at komponentens tilstand
 * alltid reflekterer det som står i URL-en – og omvendt.
 *
 * Eksempel: localhost:3000/verktoy?=fagomrade=1&fagomrade=2 osv.
 */
const useQueryParamMulti = (key: string, getQuery: URLSearchParams, queryMaps: QueryMapSetup[]): [string[], (val: string[]) => void] => {
  const [query, setQuery] = useState(getQuery.getAll(key) || []);
  const updateUrl = (newVal: string[]): void => {
    setQuery(newVal);
    getQuery.delete(key);
    queryMaps.forEach(queryMapRule => {
      if (arrayHasValue(newVal, queryMapRule.value)) {
        getQuery.append(key, queryMapRule.value);
      }
    });
    if (typeof window !== 'undefined') {
      const { protocol, pathname, host } = window.location;
      let newUrl = `${protocol}//${host}${pathname}?${getQuery.toString()}`;
      newUrl = removeTralingAndEmptyParamFromUrl(newUrl);
      window.history.replaceState({}, '/', newUrl);
    }
  };

  return [query, updateUrl];
};

/** Hjelpemetode som sjekker om string array har en bestemt verdi - ignoreCasing kan settes som param */
export const arrayHasValue = (array: string[], valueToCheck: string): boolean => {
  return array.findIndex(f => f === valueToCheck) > -1;
};

export default useQueryParamMulti;
